var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text",attrs:{"color":"pink darken-1","block":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.search}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }